import { AppJoyride } from "@/shared/ui/AppJoyride";
import { rolesTourSteps } from "./tourSteps";

type RolesTourProps = {
  run: boolean;
  onCallback: (data: {
    status?: string;
    type?: string;
    index?: number;
    action?: string;
  }) => void;
};

export function RolesTour({ run, onCallback }: RolesTourProps) {
  return (
    <AppJoyride steps={rolesTourSteps} run={run} onCallback={onCallback} />
  );
}

export { useRolesTour } from "./useRolesTour";
